module.exports = __webpack_public_path__ + "img/badge-power.d49c9792.svg";